<script lang="ts" setup>
import { useModal } from 'vue-final-modal'

import Auth from '~/components/modal-windows/Auth.vue'
import AuthAction from '~/enums/auth-action'
import { useAuthStore } from '~/store/auth'
import { useCartStore } from '~/store/cart'

const authStore = useAuthStore()
const cartStore = useCartStore()

async function openAuthModalWindow (): Promise<void> {
  await useModal({ component: Auth, attrs: { action: AuthAction.SignIn } }).open()
}
</script>

<template>
  <Notification
    v-if="cartStore.cashbackInPoints !== null && cartStore.cashbackInPoints !== 0 && !authStore.isUser"
    class="mb-6"
    is-small
    status="info"
  >
    <a
      href="#"
      @click.prevent="openAuthModalWindow"
    >Войдите</a>, чтобы получить <Cashback
      :cashback-in-points="cartStore.cashbackInPoints"
      :show-help-icon="false"
    /> iTAB Плюс за&nbsp;покупку без промокода и&nbsp;баллов.
  </Notification>
</template>
